<template>
    <div id="konfigurator-jmeno-mazlicka">

        <h1>Pettime připravujeme pro: {{ mazlicek.jmeno.value }}</h1>

        <div v-show="!validatejmeno() && tryescape" class="info-messages-box">
            <div v-if="!validatejmeno() && tryescape" class="error-msg">Jméno mazlíčka je povinné</div>
        </div>

        <div class="form-content">
            <div class="form-group"
                 v-bind:class="{ 'has-error':!validatejmeno() && tryescape,'has-success':validatejmeno() && tryescape }">
                <input v-model="mazlicek.jmeno.value" v-bind:class="{'form-control':true}" name="jmeno"
                       placeholder="Napište, jak svému psovi říkáte">
            </div>
        </div>

        <div class="infobox currently-configuring">
            <span v-html="currentCunfiguringVisitors"></span>
        </div>

        <info :krok="1"></info>

        <navigace
                :showNext="true"
                :disableNext="!valid"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>

    </div>
</template>

<script>
    import {apiDrupal} from "../api";
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'

    import navigace from './Navigace'
    import info from './Info'

    export default {
        components: {
            navigace, info
        },
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                currentCunfiguringVisitors: null,
                tryescape: false
            }
        },
        computed: {
            valid: function () {
                return (this.mazlicek.jmeno.valid = !this.$v.mazlicek.jmeno.$invalid)
            }
        },
        methods: {
            saveAndQuit: function () {
              if (this.validatejmeno()) {
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    this.$cookies.set('show_confirmation_message', 1)
                    window.location.href = 'opet-objednej/' + this.mazlicek.nid
                  }, error => {
                    console.error(error)
                  })
              } else {
                this.tryescape = true
                this.animateAfterError()
              }
            },
            next: function () {
                if (this.validatejmeno()) {
                    this.$store.dispatch('updatePet', this.mazlicek)
                        .then(response => {
                            this.$router.push({name: 'rasa'})
                        }, error => {
                            console.error(error)
                        })
                } else {
                    this.tryescape = true
                    this.animateAfterError()
                }
            },
            validatejmeno: function (event) {
                return this.mazlicek.jmeno.value !== null && this.mazlicek.jmeno.value !== ''
            },
            animateAfterError() {
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            }
        },
        validations: {
            mazlicek: {
                jmeno: {
                    value: {
                        required
                    }
                }
            }
        },
        created: function () {
            apiDrupal.get('/data/currently_configuring_visitors').then(
                response => (
                    this.currentCunfiguringVisitors = response.data.data
                )
            )
        },
        mounted: function () {
            this.mazlicek.step.current = 1
            this.$cookies.set('lastVisitedStep', 1)
            jQuery('html, body').animate({scrollTop: 0}, '500')
        }
    }
</script>



// WEBPACK FOOTER //
// 01JmenoMazlicka.vue?04d18267